import Api from 'api';
import {
  ADD_COMPANY,
  DELETE_COMPANY,
  MODIFY_COMPANY,
  SET_EDITING_COMPANY,
  TOGGLE_COMPANY,
  UPDATE_COMPANY,
  SET_CURRENT_COMPANY_ID,
} from 'companies/constants';

export const toggleCompany = (companyId) => (dispatch) =>
  dispatch({
    type: TOGGLE_COMPANY,
    meta: { id: companyId, needAuth: true },
    payload: Api.companies.toggleCompany(companyId),
  });

export const deleteCompany = (companyId) => (dispatch) =>
  dispatch({
    type: DELETE_COMPANY,
    meta: { id: companyId, needAuth: true },
    payload: Api.companies.deleteCompany(companyId),
  });

export const setEditingCompany = (id) => ({
  type: SET_EDITING_COMPANY,
  payload: { id },
});

export const addCompany = (data) => ({
  type: ADD_COMPANY,
  meta: { needAuth: true },
  payload: Api.companies.addCompany(data),
});

export const updateCompany = (id, data) => ({
  type: UPDATE_COMPANY,
  meta: { needAuth: true },
  payload: Api.companies.updateCompany(id, data),
});

export const updateCompanyRoot = (id, data) => ({
  type: UPDATE_COMPANY,
  meta: { needAuth: true },
  payload: Api.companies.updateCompanyRoot(id, data),
});

export const modifyCompany = (id, data) => ({
  type: MODIFY_COMPANY,
  payload: { id, data },
});

export const setCurrentCompanyId = (id) => ({
  type: SET_CURRENT_COMPANY_ID,
  payload: { id },
});



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/actions/companies_actions.js